/*import React from 'react'
import { AbstructVar } from '../general/general-component/abstruct-component/AbstructVar';
import { AbstructLang } from '../general/general-component/abstruct-component/AbstructLang';

function InputCustom({
    label, iconType, type, value, onChange,value1,disable
}) {
    const { mode, dispatch, navigate, langLocal } = AbstructVar();
    const { translate } = AbstructLang();
    return (
        <>
            <div dir={langLocal === 'ar' ? "rtl" : "ltr"} >
                <p className={`p-input ${mode === 'dark' ? "darktext" : "lighttext"} ${langLocal === 'ar' ? "textAlignRight" : ""}`} >{translate(label)}</p>
                <div className='around_input' style={langLocal === 'ar'?{marginLeft: "11px"} :{marginRight: "11px"}} >
                    <i className={`fa fa-${iconType} ${langLocal === 'ar' ? "border-left padding-left-15" : "border-right padding-right-15"}`}></i>
                    <input disabled={disable} className={mode === 'dark' ? "darktext" : "lighttext"} type={type} value={value1} defaultValue={value} onChange={onChange} />
                </div>
            </div>
        </>
    )
}

export default InputCustom*/



import React, { useState } from 'react';
import { AbstructVar } from '../general/general-component/abstruct-component/AbstructVar';
import { AbstructLang } from '../general/general-component/abstruct-component/AbstructLang';
import { notifyError, notifysuccess } from '../general/Notification';
const END_POINT = process.env.REACT_APP_BASE_URL_FILES;

function InputCustom({
    label, iconType, type, value, onChange, value1, disable, index, typeFileOne, name, service_name
}) {
    const { mode, langLocal } = AbstructVar();
    const { translate } = AbstructLang();
    const [loading, setLoading] = useState(false);

    const handleFileChange = async (event) => {
        const files = event.target.files;
        const filesArray = Array.from(files);
        console.log(filesArray)
        const links = [];
        const formData = new FormData();
        formData.append('service_name', service_name ? service_name : 'WAREHOUSE');

        filesArray?.forEach((file, index) => {
            formData.append(`files[${index}]`, file);
        });
        setLoading(true)
        try {
            const response = await fetch(`${END_POINT}`, {
                method: 'POST',
                body: formData
            });

            const result = await response.json();
            console.log(result)
            if (result?.status === 'Success') {
                if (typeFileOne) {
                    console.log('typeFileOne', result?.data[0]?.file_path)
                    onChange(name, result?.data[0]?.file_path)
                    setLoading(false)
                    notifysuccess(result?.message)
                } else {
                    console.log('multi', result?.data[0]?.file_path)
                    onChange(index, 'file_path', result?.data[0]?.file_path)
                    setLoading(false)
                    notifysuccess(result?.message)
                }
            }
            if (result?.status === 'Error') {
                setLoading(false)
                notifyError('The file failed to upload')
            }
        } catch (error) {
            console.log(error)
            setLoading(false)
        }
    };

    return (
        <>
            <div dir={langLocal === 'ar' ? "rtl" : "ltr"}>
                <p className={`p-input ${mode === 'dark' ? "darktext" : "lighttext"} ${langLocal === 'ar' ? "textAlignRight" : ""}`}>{translate(label)}</p>
                <div className='around_input' style={langLocal === 'ar' ? { marginLeft: "11px" } : { marginRight: "11px" }}>
                    <i className={`
                        ${loading ? `fa fa-spinner` : `fa fa-${iconType} `} 
                        ${langLocal === 'ar' ? "border-left padding-left-15" : "border-right padding-right-15"}`}></i>
                    {type === 'file' ?
                        <input
                            disabled={disable}
                            className={mode === 'dark' ? "darktext" : "lighttext"}
                            type={type}
                            onChange={handleFileChange}
                        /> : (
                            <input
                                disabled={disable}
                                className={mode === 'dark' ? "darktext" : "lighttext"}
                                type={type}
                                value={value1}
                                defaultValue={value}
                                onChange={onChange}
                            />
                        )}
                </div>
            </div>
        </>
    );
}

export default InputCustom;

